import React, { Fragment, useMemo } from 'react';
import {
	Chip,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
	useMediaQuery,
	useTheme
} from '@mui/material';
import { getContentOrder } from './helper/getContentOrder';

export const IliasContentList = ({ items }) => {
	const theme = useTheme();
	const largeView = useMediaQuery(theme.breakpoints.up('md'));
	const amountOfItemsThresholdForTwoColumnLayout = 6;
	const columns = useMemo(() => {
		if (items.length <= amountOfItemsThresholdForTwoColumnLayout) {
			return 1;
		}
		return largeView ? 2 : 1;
	}, [items.length, largeView]);
	const rows = useMemo(() => Math.ceil(items.length / columns), [items.length, columns]);
	const missingItemsArray = Array.from(Array(columns * rows - items.length).keys());

	return (
		<>
			{items.length > 0 && <List
				disablePadding
				sx={{
					display: 'grid',
					gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
					rowGap: '1px',
					background: theme.palette.grey['200'],
					overflow: 'hidden',
				}}
			>
				{items.map((item, index) => {
					const orderNumber = index + 1;
					return (
						<Fragment key={`folder-${index}`}>
							<ListItem
								disablePadding
								sx={{
									alignItems: 'stretch',
									order: getContentOrder(index, rows, columns),
									background: '#fff',
								}}
							>
								<ListItemButton href={item.link} target='_blank' sx={{ minHeight: '70px', pl: 1 }}>
									{<Chip
										label={orderNumber}
										size='small'
										variant='outlined'
										sx={{ mr: 2, minWidth: '30px', background: '#fff', color: theme.palette.grey['500'] }}
									/>}
									<ListItemIcon>
										{item.icon && <img
											src={item.icon}
											style={{
												maxWidth: '2.2em',
												maxHeight: '2.2em',
												flexShrink: 0
											}}
											alt=''
										/>}
									</ListItemIcon>
									<ListItemText
										primary={item.title}
										secondary={item.description}
										primaryTypographyProps={{
											sx: {
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												whiteSpace: 'nowrap',
											},
										}}
										secondaryTypographyProps={{
											sx: {
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												whiteSpace: 'nowrap',
											},
										}}
									/>
								</ListItemButton>
							</ListItem>
						</Fragment>
					);
				})}
				{missingItemsArray.length > 0 && missingItemsArray.map((index) => {
					return (
						<Fragment key={`missing-items-${index}`}>
							<ListItem
								disablePadding
								sx={{
									alignItems: 'stretch',
									order: getContentOrder(index + items.length, rows, columns),
									background: '#fff',
								}}
							/>
						</Fragment>
					)
				})}
			</List>}
			{items.length === 0 && <>
				<Typography variant='body1'>Bisher wurden keine Lerninhalte eingestellt.</Typography>
			</>}
		</>
	);
};
